/**
 * @internal Backs `artis.v1.layout`: a state channel over the pane list with catch-up for
 * late subscribers, plus the split/close relay. The producer (the multi-pane shell) pushes
 * the panes and registers the handlers. Mutations no-op when no producer is mounted
 * (single-pane mode). Consumers use {@link LayoutApi}, not this.
 */
export class LayoutStore {
    panes;
    subs = new Set();
    commands = null;
    setPanes = (panes) => {
        const current = this.panes;
        if (current?.length === panes.length && current.every((pane, i) => pane.id === panes[i]?.id))
            return;
        this.panes = panes;
        for (const cb of this.subs)
            cb(panes);
    };
    subscribe = (cb) => {
        this.subs.add(cb);
        if (this.panes)
            cb(this.panes);
        return () => void this.subs.delete(cb);
    };
    setCommands = (commands) => {
        this.commands = commands;
    };
    split = (paneId, orientation) => {
        this.commands?.split(paneId, orientation);
    };
    close = (paneId) => {
        this.commands?.close(paneId);
    };
}
//# sourceMappingURL=layoutStore.js.map